import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createTransferOrderButton: {
    description: 'Button label for Create Transfer Order in the Inventory Grid Header',
    defaultMessage: 'Create Transfer Order',
    id: 'KMNzN2',
  },
  createTransferOrderButtonDisabledTooltip: {
    description: 'Tooltip for Create Transfer Order button when no products are selected',
    defaultMessage: 'Select products to create a transfer order',
    id: '2p0dQQ',
  },
  createTransferOrderButtonFeatureDisabledTooltip: {
    description: 'Tooltip for Create Transfer Order button when feature is not enabled',
    defaultMessage: 'Upgrade your plan to access Transfer Orders and other advanced inventory features',
    id: '9k/e0r',
  },
  selectOriginWarehouseModalTitle: {
    description: 'Title for the modal to select origin warehouse when creating transfer order from All Warehouses view',
    defaultMessage: 'Select Origin Warehouse',
    id: 'TmfoCv',
  },
  selectOriginWarehouseModalBody: {
    description: 'Body text for the modal to select origin warehouse',
    defaultMessage: 'Please select the warehouse from which you want to transfer products.',
    id: 'ea/1D5',
  },
  selectOriginWarehouseModalConfirm: {
    description: 'Confirm button text for the origin warehouse selection modal',
    defaultMessage: 'Continue',
    id: 'eOkBYq',
  },
  selectOriginWarehouseLabel: {
    description: 'Label for the origin warehouse dropdown in the modal',
    defaultMessage: 'Origin Warehouse',
    id: 'ZE+ZMj',
  },
  selectWarehousePlaceholder: {
    description: 'Placeholder text for the warehouse dropdown',
    defaultMessage: 'Select a warehouse',
    id: 'i7hj7s',
  },
  failedToLoadInventory: {
    description: 'Error message when fetching inventory for transfer order fails',
    defaultMessage: 'Failed to load inventory',
    id: 'JBNVGG',
  },
  noProductsForTransferOrder: {
    description: 'Error message when no products could be loaded for transfer order',
    defaultMessage: 'Selected products could not be loaded',
    id: 'oiAZkh',
  },
});
